//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import PublicService from '@/service/public'
import BuildingService from '@/service/building'

import { askAuth } from '@/common/utils/getUserInfo'

import { App_User } from '@/data/user_info'

import { handleBuidingBanner } from '@/common/utils/map_view_data'

import { UserLog, sendCtmEvtLog } from '@/utils/log'

import TopTip from './_components/_top_tip'
import TopSwiper from './_components/_swiper'
import TopHeader from './_components/_top_header'
import TopTabs from './_components/_top_tabs'
import WarningTip from './_components/_warning_tip'
import LiveTip from './_components/_live_tip'

import HouseTab from './_components/_house_tab'
import BaseInfo from './_components/_base_info'
import HouseTools from './_components/_house_tools'
import OpeningInfo from './_components/_opening_info'
import RegPredict from './_components/_predict'
import HouseCount from '@/components/views/_house_count'

import VipTimeline from './_components/_vip_timeline'
import HouseContent from './_components/_content'
import HouseAttachs from './_components/_house_attachs'
import HouseResult from './_components/_result'
import SurplusHouses from './_components/_surplus_houses'

import HouseCoupons from './_components/_coupons'
import HouseComments from './_components/_comments'
import ExcellentConsultants from './_components/_excellent_consultants'
import YouLike from './_components/_you_like'
import BuildingFooter from './_components/_footer'
import ConsultantFooter from './_components/_consultant_footer'
import BuildingArticle from './article/_articles'
import BuildingEvent from './_components/_event'
import LikeTip from './_components/_like_tip'
import Sunlight from './_components/_sunlight'
import HistoryLottery from './_components/_history_lottery'
import VisitReservation from './_components/_visit_reservation'
import VisitBuilding from './_components/_visit_building_article'
import PredictOpen from './_components/_predict_open'
import PlanarGraph from './_components/_planar_graph'
import Layout from './_components/_layout'

import { getInfoItems, initIconsData } from './utils'

import getSubPage from './mixins/getSubPage'
import visit_reservation from './mixins/visit_reservation'
import consultant_footer from './mixins/consultant_footer'
import vr_video_source from './mixins/vr_video_source'

import web_720 from './mixins/web_720'
import get_userinfo from './mixins/getUserInfo'

import visit_building_article from './mixins/visit_building_article'
import { errorLog } from '@/utils/log'
import { getSmallPlanar } from './planar_graph/utils'
import building_like_tip from './mixins/building_like_tip'
import TopTools from './_components/_top_tools'
import go_icon_location from './mixins/go_icon_location'
import top_banner_recommendation from './mixins/top_banner_recommendation'

import BuildingCompare from '@/data/building_compare'
import GeneralRatings from './_components_v/_general_ratings'
import SubscribeSuccess from './_components/_subscribe_success'
import house_progress_mixins from './mixins/house_progress'
import BulletComments from './_components/_bullet_comments'
import get_bullet_comments from './mixins/get_bullet_comments'
import BuildingRank from './_components/_building_rank'
import BuildingPlate from './_components/_plate'
import HouseProgress from './_components/_progress'
import DiscussLink from './_components/_discuss'
import Consultants from '@/views/home/_consultants'
import AroundFacilities from './_components/_around_facilities'
const DEFAULT_DATA = {
    layout_image_exists: true,
    details: true,
    around_facility_exists: true,
    common_image_exists: true
}

const getDefaultTabs = (item = DEFAULT_DATA) => {
    return [
        {
            name: '户型图',
            type: 'layout',
            class: 'apartment-img',
            show: item.layout_image_exists
        },
        {
            name: '楼盘动态',
            type: 'events',
            class: 'events',
            show: true
        },
        {
            name: '楼盘详情',
            type: 'detail',
            show: Boolean(item.details)
        },
        {
            name: '周边配套',
            type: 'around',
            show: item.around_facility_exists
        },
        {
            name: '楼盘图片',
            type: 'common',
            class: 'house-img',
            show: item.common_image_exists
        }
    ]
}

const getDefaultEvents = () => {
    return {
        items: [],
        customer_service_info: {},
        building_event_author: false,
        total_count: 0,
        loading: true
    }
}

export default {
    mixins: [
        getSubPage,
        visit_reservation,
        visit_building_article,
        consultant_footer,
        vr_video_source,
        building_like_tip,
        go_icon_location,
        web_720,
        get_userinfo,
        top_banner_recommendation,
        get_bullet_comments,
        house_progress_mixins
    ],
    data () {
        return {
            openedDialog: '',
            icons: [],
            show_billboard: false,
            show_share_option: false,
            house: {
                view_count: '',
                current_houses: [],
                favourite: true
            },
            loading: true,
            inited: false,
            tabs: getDefaultTabs(),
            current_house: {
                attachment_urls: {}
            },
            current_house_index: 0,
            current_houses_tabs: [],
            excellent_consultants: [],
            events: getDefaultEvents(),
            surplus_apartment_count: 0,
            surplus_houses: [],
            scene_from: '',
            type: '',
            is_default_consultants: false,
            history_lot_houses: [],
            you_like_buidings: {},
            show_article: false,
            predict_open: null,
            layout_items: [],
        }
    },
    computed: {
        show_normal_tables () {
            return this.current_house && (!this.current_house.apartment_count_tables || !Object.keys(this.current_house.apartment_count_tables).length)
        },
        presell_help_tables () {
            if (this.current_house && this.current_house.apartment_count_tables) {
                const { apartment_count_tables } = this.current_house
                return Object.keys(apartment_count_tables).reduce((prev, title) => {
                    const tables = apartment_count_tables[title]
                    if (tables && tables.length && tables[0].length) {
                        prev.push({
                            title,
                            apartment_counts: tables
                        })
                    }
                    return prev
                }, [])
            }
        },
        is_vip () {
            return this.house.vip_type === '尊享版'
        },
        is_selling () {
            const { house_id } = this.$route.query
            return !house_id && this.house.status === '在售'
        },
        show_surplus_houses () {
            return this.scene_from === 'surplus_buildings'
                &&
                this.surplus_apartment_count > 0
                &&
                (this.is_selling || !this.house.current_houses || !this.house.current_houses.length || this.current_house.status === '即将预售')
        },
        open_type () {
            return this.is_consultant ? '' : 'share'
        },
        has_current_house() {
            const { current_houses } = this.house
            return current_houses && current_houses.length
        },
        is_opened () {
            const { is_selling, house } = this
            return !is_selling && this.has_current_house
        },
        show_result () {
            const { is_opened, current_house } = this
            return Boolean(is_opened && current_house.status !== '即将预售')
        },
        show_house_count_table () {
            return this.presell_help_tables || this.show_normal_tables
        },
        show_price_desc () {
            const { price_desc_arr, surplus_houses_price } = this.house
            return this.is_selling && price_desc_arr && price_desc_arr.length && surplus_houses_price != '正在计算' && !this.show_surplus_houses
        },
        is_guaranteed_leased_house() {
            return (
                this.current_house &&
                this.current_house.exist_values &&
                this.current_house.exist_values.indexOf('保障性租赁住房') > -1
            )
        },
    },
    mounted () {
        const { type } = this.$route.query
        this.type = type
        this.checkSubPage()
        this.getMyConsultant()
        console.log(Service)
        Service.init().then(() => {
            this.getData()
            const { building_id, scene_params } = this.$route.query
            UserLog.viewBuilding(building_id, scene_params || '')
        })
    },
    methods: {
        toggleFavourite(log_name) {
            App_User.get().then((data) => {
                if (data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    const { favourite, id } = this.house
                    const params = {
                        followable_type: 'Fc::Building',
                        followable_id: id
                    }
                    const { building_ids } = this.consultant || {}
                    if (favourite) {
                        Service.delFollow(params)
                    } else {
                        if (building_ids && building_ids.includes(id)) {
                            Service.addScore('subscribe_belonging_building')
                        }
                        Service.addFollow(params)
                        this.$sendCtmEvtLog(log_name || '订阅楼盘')
                    }
                    this.house.favourite = !favourite
                }
            })

        },
        getMyConsultant () {
            Service.getMyConsultant().then(data => {
                this.consultant = data
            })
        },
        getYouLike () {
            if (this.is_vip) {
                return
            }
            const { building_id } = this.$route.query
            BuildingService.getYouLike(building_id).then((data) => {
                this.you_like_buidings = data
            })
        },
        getLottery () {
            const { building_id, consultant_group_id, house_id } = this.$route.query
            if (house_id) {
                return
            }
            BuildingService.getHistoryLottery(building_id).then(({ items }) => {
                items.forEach((history) => {
                    history.href = `/building?building_id=${building_id}&house_id=${history.id}&consultant_group_id=${consultant_group_id||''}`
                })
                this.history_lot_houses = items
            })
        },
        goCall () {
            if (this.house.has_telephone) {
                this.$showCallModal(this.getPhoneCall, '楼盘详情页——电话拨打')
            } else {
                this.$checkPostAuth()
            }
        },
        getPhoneCall () {
            PublicService.getPhonePosition({
                building_id: this.house.id
            }).then(({ phone }) => {
                this.$wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        },
        getData () {
            this.loading = true
            const { share_by_consultant_uid } = App_User
            const { house_id, building_id, consultant_group_id, from, type, status, scene_params, sub_page } = this.$route.query
            this.scene_from = from
            const is_surplus = this.scene_from === 'surplus_buildings'
            const params = {
                house_id,
                consultant_group_id,
                status,
                share_by_consultant_uid: share_by_consultant_uid || scene_params
            }
            BuildingService.getBuilding(building_id, params).then(data => {
                if (data.usage === '商业') {
                    let params_str = `building_id=${building_id}`
                    if (type) {
                        params_str += `&type=${type}`
                    }
                    if (params.share_by_consultant_uid) {
                        params_str += `&share_by_consultant_uid=${params.share_by_consultant_uid}`
                    }
                    if (sub_page) {
                        params_str += `&sub_page=${sub_page}`
                    }
                    this.$router.replace({
                        path: `/building/business?${params_str}`
                    })
                    return
                }
                this.current_houses_tabs = data.current_houses.map((house) => house.name)
                data.photos_urls = data.photos_urls.map(handleBuidingBanner)
                data.planar_graph_url = getSmallPlanar(data.planar_graph_url)
                if (data.vr_resource && data.vr_resource.vr_photo_url) {
                    data.vr_resource.vr_photo_url = handleBuidingBanner(data.vr_resource.vr_photo_url)
                }
                data.status = is_surplus ? '在售' : data.status === '即将取证' ? '即将预售' : data.status
                if (!is_surplus) {
                    data.current_houses.forEach((item) => {
                        item.has_house_price = item.exist_values && item.exist_values.indexOf('house_prices') > -1
                    })
                    this.current_house = data.current_houses.length ? data.current_houses[0] : {}
                    this.current_house_index = 0
                }

                data.favourite = Boolean(data.follow_info && data.follow_info.id)

                this.tabs = getDefaultTabs(data)

                this.icons = initIconsData({
                        ...data,
                        house_id
                })

                const { details, surplus_apartment_count, surplus_houses } = data
                this.surplus_apartment_count = surplus_apartment_count
                this.surplus_houses = surplus_houses
                const items = getInfoItems(data.usage)
                data.house_info = items.reduce((prev, key) => {
                    if (details && details[key]) {
                        prev.push({
                            key,
                            value: details[key]
                        })
                    }
                    return prev
                }, [])
                const predict_data = details['预开盘信息']
                if (predict_data) {
                    this.predict_open = Object.keys(predict_data).reduce((rs, key) => {
                        const val = predict_data[key]
                        if (val != null && val != undefined && val != '') {
                            rs.push({
                                key,
                                val
                            })
                        }
                        return rs
                    }, [])
                }

                data.longitude = data.location ? data.location.split(',')[0] : ''
                data.latitude = data.location ? data.location.split(',')[1] : ''

                data.view_count = data.view_count >= 10000 ? `${(data.view_count / 10000).toFixed(1)}w` : data.view_count

                this.house = data
                this.loading = false
                this.inited = true
                this.getExcellentConsultant(building_id)
                this.getUser(building_id)
                this.$refs.house_comments.getData(this.house.id)
                // this.$refs.house_result.getData(this.house.id)
                setTimeout(this.getOtherInfo)
            }).catch(err => {
                console.log(123, err)
                errorLog(`get_building_error ${JSON.stringify(err)}, options: ${JSON.stringify(this.$route.query)}`)
            })
        },
        goLocation () {
            const { latitude, longitude, name, address } = this.house
            sendCtmEvtLog('基本信息地图点击')
            if (latitude && longitude) {
                wx.openLocation({
                    latitude: Number(latitude),
                    longitude: Number(longitude),
                    name,
                    address
                })
            }
        },
        getOtherInfo () {
            this.getBulletComments()
            this.getLayouts()
            this.getEvents()
            this.getYouLike()
            this.getLottery()
            this.getVisitBuildingArticle()
        },
        getExcellentConsultant (building_id) {
            BuildingService.excellentConsultants(building_id).then((data) => {
                this.excellent_consultants = data.slice(0, 3)
            })
        },
        getEvents () {
            const { building_id } = this.$route.query
            BuildingService.getEvent(building_id, {
                page: 1,
                per: 1
            }).then((data) => {
                this.events = {
                    items: data.items && data.items.length ? data.items.slice(0, 1) : [],
                    is_consultant: data.is_consultant,
                    building_event_author: data.building_event_author,
                    customer_service_info: {},
                    total_count: data.total_count,
                    loading: false
                }
                this.$set(this.tabs, 1, {
                    ...this.tabs[1],
                    show: Boolean(data.total_count)
                })
                App_User.customer_service_info().then((customer_service_info) => {
                    this.events.customer_service_info = customer_service_info
                })
                
                console.log(this.events);
            })
        },
        async getLayouts () {
            const { building_id } = this.$route.query
            const data = await BuildingService.getImgs(building_id, 'layout', {})
            this.layoutItemsSort(data.items)
        },
        layoutItemsSort(items) {
            const house_ids = this.house.current_houses.map(({ id }) => id)
            const current_urls = items.sort(
                (a, b) => {
                    return house_ids.indexOf(a.house_id) > -1 && house_ids.indexOf(b.house_id) === -1
                    ? -1 : 1
                }
            ).map((item) => {
                return {
                    ...item,
                    vr_url: ''
                }
            })
            this.layout_items = current_urls
        },
        goAddComments () {
            const { name, id } = this.house
            this.$router.push({
                path:`/building/comments/add?building_id=${id || ''}&name=${name}`
            })
        },
        goTab (e) {
            const { type, name, index } = e.currentTarget.dataset
            if (!this.tabs[index].show) {
                return
            }
            this.tabLog(e)
            if (type === 'common' || type === 'layout') {
                this.goPreview(type, name)
            } else if (type === 'events') {
                this.goEvent()
            } else if (type === 'around') {
                this.goAround('metro')
            } else {
                this.goHouseInfo(type)
            }
        },
        goHouseInfo (type = 'detail') {
            const { id, building_id } = this.$route.query
            this.goSubPagePath(`/building/info?type=${type}&id=${id}&building_id=${building_id || ''}`)
        },
        goPreview (type, name) {
            if (this.loading) {
                return
            }
            const { building_id } = this.$route.query
            const title = `${this.house.name}-${name}`
            let house_id = this.house.current_houses.map(({ id }) => id).join(',')
            if (type === 'price') {
                house_id = this.current_house.id
            }
            this.goSubPagePath(`/building/img_preview?house_id=${house_id || ''}&type=${type}&title=${title}&building_id=${building_id || ''}`)
        },
        goAround (category = '') {
            this.goSubPagePath(`/building/around_facilities/map?id=${this.house.id}&type=building&category=${category}`)
        },
        goComments () {
            this.goSubPagePath(`/building/comments?building_id=${this.house.id || ''}&name=${this.house.name}`)
        },
        goPredict () {
            this.goSubPagePath(`/building/interest_forecast/main?building_id=${this.house.id}&house_id=${this.current_house.id}`)
        },
        changeCurrentHouse (index) {
            this.current_house = this.house.current_houses[index]
            this.current_house_index = index
        },
        goConsultant () {
            const { consultant_group_id } = this.$route.query
            this.goSubPagePath(`/consultants/filter/main?id=${this.house.id}&consultant_group_id=${consultant_group_id || ''}&from=楼盘详情`)
        },
        goBuildingArticle () {
            const { building_id } = this.$route.query
            this.goSubPagePath(`/building/article/main?building_id=${building_id}`)
        },
        goEvent () {
            const { building_id } = this.$route.query
            this.goSubPagePath(`/building/event?building_id=${building_id}`)
        },
        openLayoutDetail (id) {
            const { building_id } = this.$route.query
            this.goSubPagePath(`/building/layout_detail?building_id=${building_id}&layout_id=${id}`)
        },
        tabLog (e) {
            const { name: eventName } = e.currentTarget.dataset
            sendCtmEvtLog('楼盘详情页——' + eventName)
        },
        sendRankLog() {
            this.$sendCtmEvtLog('楼盘详情-榜单入口点击', { building_id: this.house.id })
        }
    },
    components: {
        VisitReservation,
        TopTip,
        TopSwiper,
        TopHeader,
        TopTabs,
        LiveTip,

        Sunlight,
        HouseTab,
        BaseInfo,
        HouseTools,
        OpeningInfo,
        RegPredict,
        HouseCount,
        Layout,

        VipTimeline,
        HouseContent,
        HouseAttachs,
        HouseResult,
        HouseComments,
        ExcellentConsultants,
        SurplusHouses,

        YouLike,

        BuildingFooter,
        ConsultantFooter,

        BuildingArticle,
        BuildingEvent,
        LikeTip,
        HistoryLottery,
        WarningTip,
        HouseCoupons,
        VisitBuilding,
        PredictOpen,
        PlanarGraph,
        TopTools,
        SubscribeSuccess,

        BulletComments,
        BuildingRank,
        BuildingPlate,

        DiscussLink,
        HouseProgress,
        GeneralRatings,
        AroundFacilities
    }
}
